import React, { useState, useEffect, useContext } from "react"
import { Nav, Tabs, Tab } from "react-bootstrap"
import {
  MdDeleteOutline,
  MdOutlineSwapVert,
  MdOutlineSettings,
} from "react-icons/md"
import "./TabsFacultades.css"
import Loading from "./Loading"
import UAI from "../UAI"
import { UsuarioContext } from "../Context/Usuario"
import log from "loglevel"
import { useParams } from "react-router-dom"
import FiltrosTabs from "./FiltrosTabs"

/**
 * Componente para el despliegue de Tabs de Unidades de Venta y Facultades
 **/
const TabsFacultades = (props) => {
  /** Información del usuario actualmente interactuando con la aplicación **/
  const { usuario } = useContext(UsuarioContext)
  /** Tipo de ordenamiento de tabs, por facultad o por subtab **/
  const [tabType, setTabType] = useState(UAI.obtieneTabTypeActual(usuario))
  /**
   * Crea el arreglo de tabs y subtabs para navegación
   * @returns arreglo de tabs con sus respectivos subtabs
   */
  const cargaTabs = (_tabType) => {
    // Inicializa arreglo de tabs
    let _tabs = []
    // Tabs pueden ser unidades de venta o facultades, dependiendo de tabType
    let tab = "facultades"
    let subtab = "unidadesventa"
    // Si el orden no es facultades -> unidades de venta, intercambiamos las variables
    if (_tabType === UAI.tabTypes.UNIDADESVENTA_FACULTADES) {
      let _tmp = tab
      tab = subtab
      subtab = _tmp
    }
    // Filtramos en caso de definirse un filtro en las propiedades
    let _objetosTabs = usuario[tab]
    Object.values(_objetosTabs)
      .filter((_obj) => {
        return (
          !props.filtrarSubtabs || props.filtrarSubtabs.indexOf(_obj.key) >= 0
        )
      })
      // Ordenamos las unidades de venta por el atributo orden de cada una
      .sort(function (obja, objb) {
        let oa = obja.orden
          ? obja.orden
          : obja.nombre
          ? obja.nombre.charCodeAt(0)
          : 0
        let ob = objb.orden
          ? objb.orden
          : objb.nombre
          ? objb.nombre.charCodeAt(0)
          : 0
        return oa - ob
      })
      // A cada unidad de venta le calculamos sus subtabs, dependiendo de si tiene cohortes para esa combinación
      .forEach((_objetoTab) => {
        // Arreglo de subtabs facultades
        let _subtabs = []
        Object.keys(_objetoTab[subtab])
          // Ordenamos los subtabs de acuerdo a su atributo orden, definido en duro en data json
          .sort(function (a, b) {
            let fa = usuario[subtab][a]
              ? usuario[subtab][a].orden
              : a.charCodeAt(0)
            let fb = usuario[subtab][b]
              ? usuario[subtab][b].orden
              : b.charCodeAt(0)
            return fa - fb
          })
          .forEach((_objetoSubtabkey) => {
            let _objetoSubtab = usuario[subtab][_objetoSubtabkey]
            if (!_objetoSubtab) {
              throw new Error(
                "Subtab inválido " + subtab + " -> " + _objetoSubtabkey
              )
            }
            // Filtramos por solo aquellas facultades que poseen cohortes en el período
            let _uv =
              tab === "unidadesventa" ? _objetoTab.key : _objetoSubtab.key
            let _fac =
              tab === "unidadesventa" ? _objetoSubtab.key : _objetoTab.key
            if (
              usuario["unidadesventa"][_uv].totalescohortes[_fac][
                usuario.periodo
              ] > 0
            ) {
              _subtabs.push({
                key: _objetoSubtab.key,
                nombre: _objetoSubtab.nombretab
                  ? _objetoSubtab.nombretab
                  : _objetoSubtab.nombre,
              })
            }
          })
        // Agregamos el tab de UV solo si tiene facultades que a su vez tengan cohortes
        if (_subtabs.length > 0) {
          _tabs.push({
            key: _objetoTab.nombrecorto,
            nombre: _objetoTab.nombretab
              ? _objetoTab.nombretab
              : _objetoTab.nombre,
            subtabs: _subtabs,
          })
        }
      })
    return _tabs
  }

  /**
   * Obtiene los subtabs activos para un tipo de tab específico
   * @param {String} _tabType
   * @param {Object} usuario
   * @returns
   */
  const cargaActiveSubtabs = (_tabType, usuario, defaults) => {
    // En la primera carga, se considera que resumen (en caso de existir) será el primer subtab seleccionado
    let _activeSubtabs = {}
    if (_tabType === UAI.tabTypes.UNIDADESVENTA_FACULTADES) {
      Object.values(usuario["unidadesventa"]).forEach((_subtab) => {
        if (props.resumen) {
          _activeSubtabs[_subtab.key] = "resumen"
        } else {
          _activeSubtabs[_subtab.key] =
            Object.keys(_subtab.facultades).find((f) => {
              return f === defaults.facultad
            }) || Object.keys(_subtab.facultades)[0]
        }
      })
    } else {
      Object.values(usuario.facultades).forEach((fac) => {
        if (props.resumen) {
          _activeSubtabs[fac.key] = "resumen"
        } else {
          _activeSubtabs[fac.key] =
            Object.keys(fac["unidadesventa"]).find((uk) => {
              return uk === defaults.unidadventa
            }) || Object.keys(fac["unidadesventa"])[0]
        }
      })
    }
    return _activeSubtabs
  }

  /** Tab activo **/
  const [activeTab, setActiveTab] = useState(null)
  /** Subtab activos **/
  const [activeSubtabs, setActiveSubtabs] = useState(null)
  /** Filtros activos **/
  const [activeFilters, setActiveFilters] = useState(null)
  /** Agrupamiento */
  const [groupby, setGroupby] = useState(UAI.obtieneGroupbyActual(usuario))
  /** Offcanvas para filtros */
  const [showFilterOffcanvas, setShowFilterOffcanvas] = useState(false)
  /** Arreglo de columnas que se visualizarán en el reporte */
  const [columns, setColumns] = useState(
    UAI.obtieneColumnsActual(usuario, props.tipoColumnas)
  )
  /** Tabs de la interfaz (contienen a cad subtab) **/
  const [tabs, setTabs] = useState(cargaTabs(UAI.obtieneTabTypeActual(usuario)))
  /** Parámetros por URL **/
  const params = useParams()

  /**
   * Método de inicialización del componente, se ejecuta al cargarse y cada vez que cambie
   * alguna variable relevante
   */
  useEffect(() => {
    log.debug("UseEffect TabsFacultades!")
    // Buscamos qué tabs se seleccionarán por defecto
    let defaults = UAI.obtieneTabDefaults(usuario)
    // Revisamos el caché del navegador para ver si hay facultad y/o unidad de venta seleccionada
    let storage = window.localStorage
    if (
      storage.getItem("facultad-seleccionada") &&
      UAI.obtieneFacultadPorNombrecorto(
        storage.getItem("facultad-seleccionada")
      ) &&
      storage.getItem("unidadventa-seleccionada") &&
      UAI.obtieneUnidadVentaPorNombrecorto(
        storage.getItem("unidadventa-seleccionada")
      )
    ) {
      defaults.facultad = storage.getItem("facultad-seleccionada")
      defaults.unidadventa = storage.getItem("unidadventa-seleccionada")
    }
    // Revisión de tabs indicados en URL
    if (
      params.facultad &&
      Array.isArray(params.facultad.split("+")) &&
      params.facultad.split("+").length === 2 &&
      UAI.obtieneFacultadPorNombrecorto(params.facultad.split("+")[0]) &&
      usuario["unidadesventa"][params.facultad.split("+")[1]]
    ) {
      defaults.facultad = params.facultad.split("+")[0]
      defaults.unidadventa = params.facultad.split("+")[1]
    }
    // En la primera carga, se considera que resumen (en caso de existir) será el primer subtab seleccionado
    let _activeSubtabs = cargaActiveSubtabs(tabType, usuario, defaults)
    setActiveSubtabs(_activeSubtabs)
    // Definimos el tab activo en la primera carga
    if (tabType === UAI.tabTypes.UNIDADESVENTA_FACULTADES) {
      setActiveTab(defaults.unidadventa)
      if (props.toggleTabs) {
        props.toggleTabs({
          unidadventa: defaults.unidadventa,
          facultad: _activeSubtabs[defaults.unidadventa],
          filters: activeFilters,
          type: tabType,
          groupby: groupby,
          columns: columns,
        })
      }
    } else {
      setActiveTab(defaults.facultad)
      if (props.toggleTabs) {
        props.toggleTabs({
          facultad: defaults.facultad,
          unidadventa: _activeSubtabs[defaults.facultad],
          filters: activeFilters,
          type: tabType,
          groupby: groupby,
          columns: columns,
        })
      }
    }
  }, [
    usuario,
    props.filtrarSubtabs,
    props.toggleTabs,
    tabType,
    params.facultad,
  ])

  /**
   * Cambia el tab activo (puede ser facultad o unidad de venta)
   * @param {String} newTab
   */
  const toggleTab = (newTab) => {
    let storage = window.localStorage
    setActiveTab(newTab)
    if (tabType === UAI.tabTypes.UNIDADESVENTA_FACULTADES) {
      storage.setItem("unidadventa-seleccionada", newTab)
      storage.setItem("facultad-seleccionada", activeSubtabs[newTab])
      if (props.toggleTabs) {
        props.toggleTabs({
          unidadventa: newTab,
          facultad: activeSubtabs[newTab],
          filters: activeFilters,
          type: tabType,
          groupby: groupby,
          columns: columns,
        })
      }
    } else {
      storage.setItem("unidadventa-seleccionada", activeSubtabs[newTab])
      storage.setItem("facultad-seleccionada", newTab)
      if (props.toggleTabs) {
        props.toggleTabs({
          facultad: newTab,
          unidadventa: activeSubtabs[newTab],
          filters: activeFilters,
          type: tabType,
          groupby: groupby,
          columns: columns,
        })
      }
    }
  }

  const toggleSubtab = (newTab) => {
    let newactiveSubtab = JSON.parse(JSON.stringify(activeSubtabs))
    newactiveSubtab[activeTab] = newTab
    setActiveSubtabs(newactiveSubtab)
    if (tabType === UAI.tabTypes.UNIDADESVENTA_FACULTADES) {
      if (props.toggleTabs) {
        props.toggleTabs({
          facultad: newTab,
          unidadventa: activeTab,
          filters: activeFilters,
          type: tabType,
          groupby: groupby,
          columns: columns,
        })
      }
    } else {
      if (props.toggleTabs) {
        props.toggleTabs({
          unidadventa: newTab,
          facultad: activeTab,
          filters: activeFilters,
          type: tabType,
          groupby: groupby,
          columns: columns,
        })
      }
    }
  }

  /**
   * Cambia el valor del orden de los tabs entre Facultades/UVs y viceversa
   */
  const toggleTabType = () => {
    // El nuevo tabType
    let _newTabType =
      tabType === UAI.tabTypes.UNIDADESVENTA_FACULTADES
        ? UAI.tabTypes.FACULTADES_UNIDADESVENTA
        : UAI.tabTypes.UNIDADESVENTA_FACULTADES
    log.debug(
      "Cambiando orden de tabs a " +
        (_newTabType === UAI.tabTypes.FACULTADES_UNIDADESVENTA
          ? "fac->uv"
          : "uv->fac")
    )
    // Guardamos el nuevo tabType en el local storage
    UAI.cambiarTabTypeActual(_newTabType)
    setActiveTab(null)
    setActiveSubtabs(null)
    setTabs(cargaTabs(_newTabType))
    setTabType(_newTabType)
  }

  const obtieneFacultadUnidadventa = () => {
    let facultad = null
    let unidadventa = null
    if (tabType === UAI.tabTypes.FACULTADES_UNIDADESVENTA) {
      facultad = activeTab
      unidadventa = activeSubtabs[activeTab]
    } else {
      unidadventa = activeTab
      facultad = activeSubtabs[activeTab]
    }
    return { facultad: facultad, unidadventa: unidadventa }
  }

  const obtieneCohortes = () => {
    let tabs = obtieneFacultadUnidadventa()
    let facultad = tabs.facultad
    let unidadventa = tabs.unidadventa
    if (facultad && facultad.includes("resumen")) {
      let cohortesusuario = Object.keys(
        usuario["unidadesventa"][unidadventa]["facultades"]
      ).reduce((prev, current) => {
        prev = prev.concat(
          Object.keys(
            usuario["facultades"][current]["unidadesventa"][unidadventa]
          ).reduce((prev2, current2) => {
            prev2.push(parseInt(current2))
            return prev2
          }, [])
        )
        return prev
      }, [])
      return cohortesusuario
    }
    if (unidadventa && unidadventa.includes("resumen")) {
      let cohortesusuario = Object.keys(
        usuario["facultades"][facultad]["unidadesventa"]
      ).reduce((prev, current) => {
        prev = prev.concat(
          Object.keys(
            usuario["facultades"][facultad]["unidadesventa"][current]
          ).reduce((prev2, current2) => {
            prev2.push(parseInt(current2))
            return prev2
          }, [])
        )
        return prev
      }, [])
      return cohortesusuario
    }
    let cohortesusuario = Object.keys(
      usuario["facultades"][facultad]["unidadesventa"][unidadventa]
    ).reduce((prev, current) => {
      prev.push(parseInt(current))
      return prev
    }, [])
    return cohortesusuario
  }

  const addColumn = (c) => {
    let newValue = JSON.parse(JSON.stringify(columns))
    let tabs = obtieneFacultadUnidadventa()
    let index =
      props.tipoColumnas === "postulantes"
        ? tabs.facultad + "-" + tabs.unidadventa
        : props.view
    newValue = newValue || {}
    newValue[index] = newValue[index] || []
    if (newValue[index].indexOf(c) < 0) {
      newValue[index].push(c)
    }
    setColumns(newValue)
    if (props.toggleTabs) {
      props.toggleTabs({
        facultad: tabs.facultad,
        unidadventa: tabs.unidadventa,
        activeFilters: activeFilters,
        type: tabType,
        groupby: groupby,
        columns: newValue,
      })
    }
  }

  const deleteColumn = (c) => {
    let newValue = JSON.parse(JSON.stringify(columns))
    let tabs = obtieneFacultadUnidadventa()
    let index =
      props.tipoColumnas === "postulantes"
        ? tabs.facultad + "-" + tabs.unidadventa
        : props.view
    newValue = newValue || {}
    newValue[index] = newValue[index] || []
    let colIndex = newValue[index].indexOf(c)
    if (colIndex >= 0) {
      newValue[index].splice(colIndex, 1)
    }
    log.debug(newValue[index])
    setColumns(newValue)
    if (props.toggleTabs) {
      props.toggleTabs({
        facultad: tabs.facultad,
        unidadventa: tabs.unidadventa,
        activeFilters: activeFilters,
        type: tabType,
        groupby: groupby,
        columns: newValue,
      })
    }
  }

  const moveColumn = (c, delta) => {
    let newValue = JSON.parse(JSON.stringify(columns))
    let tabs = obtieneFacultadUnidadventa()
    let index =
      props.tipoColumnas === "postulantes"
        ? tabs.facultad + "-" + tabs.unidadventa
        : props.view
    newValue = newValue || {}
    newValue[index] = newValue[index] || []
    let colIndex = newValue[index].indexOf(c)
    if (colIndex + delta < 0 || colIndex + delta >= newValue[index].length) {
      return
    }
    let newIndex = colIndex + delta
    let tmp = newValue[index][colIndex]
    newValue[index][colIndex] = newValue[index][newIndex]
    newValue[index][newIndex] = tmp

    setColumns(newValue)
    if (props.toggleTabs) {
      props.toggleTabs({
        facultad: tabs.facultad,
        unidadventa: tabs.unidadventa,
        activeFilters: activeFilters,
        type: tabType,
        groupby: groupby,
        columns: newValue,
      })
    }
  }

  const moveColumnUp = (c) => {
    moveColumn(c, -1)
  }

  const moveColumnDown = (c) => {
    moveColumn(c, +1)
  }

  const setFilterFechaInicio = (start, end) => {
    let newValue = JSON.parse(JSON.stringify(activeFilters))
    let tabs = obtieneFacultadUnidadventa()
    let index = tabs.facultad + "-" + tabs.unidadventa
    newValue = newValue || {}
    newValue[index] = newValue[index] || {}
    newValue[index].fechainicio = { start: start, end: end }
    setActiveFilters(newValue)
    if (props.toggleTabs) {
      props.toggleTabs({
        facultad: tabs.facultad,
        unidadventa: tabs.unidadventa,
        activeFilters: newValue,
        type: tabType,
        groupby: groupby,
        columns: columns,
      })
    }
  }

  const deleteFilterFechaInicio = () => {
    let tabs = obtieneFacultadUnidadventa()
    let index = tabs.facultad + "-" + tabs.unidadventa
    let newValue = JSON.parse(JSON.stringify(activeFilters))
    if (newValue && newValue[index] && newValue[index].fechainicio) {
      delete newValue[index].fechainicio
    }
    setActiveFilters(newValue)
    if (props.toggleTabs) {
      props.toggleTabs({
        facultad: tabs.facultad,
        unidadventa: tabs.unidadventa,
        activeFilters: newValue,
        type: tabType,
        groupby: groupby,
        columns: columns,
      })
    }
  }

  const addFilterCoordinadoraAdmision = (c) => {
    let newValue = JSON.parse(JSON.stringify(activeFilters))
    let tabs = obtieneFacultadUnidadventa()
    let index = tabs.facultad + "-" + tabs.unidadventa
    newValue = newValue || {}
    newValue[index] = newValue[index] || {}
    newValue[index].coordinadorasadmision =
      newValue[index].coordinadorasadmision || []
    if (newValue[index].coordinadorasadmision.indexOf(c) < 0) {
      newValue[index].coordinadorasadmision.push(c)
    }
    setActiveFilters(newValue)
    if (props.toggleTabs) {
      props.toggleTabs({
        facultad: tabs.facultad,
        unidadventa: tabs.unidadventa,
        activeFilters: newValue,
        type: tabType,
        groupby: groupby,
        columns: columns,
      })
    }
  }

  const deleteFilterCoordinadoraAdmision = (c) => {
    let tabs = obtieneFacultadUnidadventa()
    let index = tabs.facultad + "-" + tabs.unidadventa
    let newValue = JSON.parse(JSON.stringify(activeFilters))
    if (
      newValue &&
      newValue[index] &&
      newValue[index].coordinadorasadmision &&
      newValue[index].coordinadorasadmision.indexOf(c) >= 0
    ) {
      newValue[index].coordinadorasadmision.splice(
        newValue[index].coordinadorasadmision.indexOf(c),
        1
      )
    }
    setActiveFilters(newValue)
    if (props.toggleTabs) {
      props.toggleTabs({
        facultad: tabs.facultad,
        unidadventa: tabs.unidadventa,
        activeFilters: newValue,
        type: tabType,
        groupby: groupby,
        columns: columns,
      })
    }
  }

  const changeGroupBy = (_groupby) => {
    let tabs = obtieneFacultadUnidadventa()
    let newValue = JSON.parse(JSON.stringify(groupby))
    newValue = newValue || {}
    newValue[tabs.facultad + "-" + tabs.unidadventa] = _groupby
    let storage = window.localStorage
    storage.setItem("groupby", JSON.stringify(newValue))
    setGroupby(newValue)
    if (props.toggleTabs) {
      props.toggleTabs({
        facultad: tabs.facultad,
        unidadventa: tabs.unidadventa,
        activeFilters: activeFilters,
        type: tabType,
        groupby: newValue,
        columns: columns,
      })
    }
  }

  const changeColumn = (_columns) => {
    let tabs = obtieneFacultadUnidadventa()
    let index = tabs.facultad + "-" + tabs.unidadventa
    let newValue = JSON.parse(JSON.stringify(columns))
    newValue = newValue || {}
    newValue[index] = newValue[index] || []
    let colIndex = newValue[index].indexOf(_columns)
    if (colIndex < 0) {
      newValue[index].push(_columns)
    } else {
      newValue[index].splice(colIndex, 1)
    }
    let storage = window.localStorage
    storage.setItem("columns" + props.tipoColumnas, JSON.stringify(newValue))
    setColumns(newValue)
    if (props.toggleTabs) {
      props.toggleTabs({
        facultad: tabs.facultad,
        unidadventa: tabs.unidadventa,
        activeFilters: activeFilters,
        type: tabType,
        groupby: groupby,
        columns: newValue,
      })
    }
  }

  const addFilterCoordinadoraPrograma = (c) => {
    let newValue = JSON.parse(JSON.stringify(activeFilters))
    let tabs = obtieneFacultadUnidadventa()
    let index = tabs.facultad + "-" + tabs.unidadventa
    newValue = newValue || {}
    newValue[index] = newValue[index] || {}
    newValue[index].coordinadorasprogramas =
      newValue[index].coordinadorasprogramas || []
    if (newValue[index].coordinadorasprogramas.indexOf(c) < 0) {
      newValue[index].coordinadorasprogramas.push(c)
    }
    setActiveFilters(newValue)
    if (props.toggleTabs) {
      props.toggleTabs({
        facultad: tabs.facultad,
        unidadventa: tabs.unidadventa,
        activeFilters: newValue,
        type: tabType,
        groupby: groupby,
        columns: columns,
      })
    }
  }

  const deleteFilterCoordinadoraPrograma = (c) => {
    let tabs = obtieneFacultadUnidadventa()
    let index = tabs.facultad + "-" + tabs.unidadventa
    let newValue = JSON.parse(JSON.stringify(activeFilters))
    if (
      newValue &&
      newValue[index] &&
      newValue[index].coordinadorasprogramas &&
      newValue[index].coordinadorasprogramas.indexOf(c) >= 0
    ) {
      newValue[index].coordinadorasprogramas.splice(
        newValue[index].coordinadorasprogramas.indexOf(c),
        1
      )
    }
    setActiveFilters(newValue)
    if (props.toggleTabs) {
      props.toggleTabs({
        facultad: tabs.facultad,
        unidadventa: tabs.unidadventa,
        activeFilters: newValue,
        type: tabType,
        groupby: groupby,
        columns: columns,
      })
    }
  }

  if (
    activeTab === null ||
    activeSubtabs === null ||
    usuario === null ||
    usuario.unidadesventa === null
  ) {
    return <Loading />
  }

  let cohortesusuario = obtieneCohortes()
  let currentTabs = obtieneFacultadUnidadventa()
  let index = currentTabs.facultad + "-" + currentTabs.unidadventa
  let esResumen =
    currentTabs.facultad === "resumen" || currentTabs.unidadventa === "resumen"

  return (
    <>
      <div className="uai-tabs">
        <div>
          <Tabs
            activeKey={activeTab}
            id="uvfac-tabs"
            className={
              "with-arrow lined nav-pills " +
              (tabType === UAI.tabTypes.UNIDADESVENTA_FACULTADES
                ? "tab-uv"
                : "tab-fac")
            }
            onSelect={(selectedTab) => {
              toggleTab(selectedTab)
            }}
          >
            {tabs.map((tab) => (
              <Tab
                key={tab.key}
                eventKey={tab.key}
                className={
                  activeTab === tab.key ? "tour-active" : "tour-inactive"
                }
                title={
                  <>
                    <span className="d-none d-sm-block">{tab.nombre}</span>
                    <span className="d-sm-none">{tab.key.toUpperCase()}</span>
                  </>
                }
              >
                <Nav
                  variant="tabs"
                  activeKey={tab.key + "-" + activeSubtabs[tab.key]}
                  onSelect={(k) => {
                    toggleSubtab(k.split("-")[1])
                  }}
                  className="with-arrow lined nav-pills"
                >
                  {props.resumen && (
                    <Nav.Item>
                      <Nav.Link eventKey={tab.key + "-" + "resumen"}>
                        <span className="d-block">
                          <span className="d-none d-sm-block">Resumen</span>
                          <span className="d-sm-none">Res</span>
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                  )}
                  {props.resumen && (
                    <>
                      <Nav.Item>
                        <Nav.Link eventKey={tab.key + "-" + "resumentodos"}>
                          <span className="d-block">
                            <span className="d-none d-sm-block">Todos</span>
                            <span className="d-sm-none">Todo</span>
                          </span>
                        </Nav.Link>
                      </Nav.Item>
                    </>
                  )}
                  {tab.subtabs.map((subtab) => (
                    <Nav.Item
                      key={tab.key + "-" + subtab.key}
                      className={
                        (tabType === UAI.tabTypes.UNIDADESVENTA_FACULTADES
                          ? "tab-fac "
                          : "tab-uv ") +
                        (activeSubtabs[activeTab] === subtab.key
                          ? "tour-active"
                          : "tour-inactive")
                      }
                    >
                      <Nav.Link eventKey={tab.key + "-" + subtab.key}>
                        <span className="d-none d-sm-block">
                          {subtab.nombre}
                        </span>
                        <span className="d-sm-none">
                          {subtab.key.toUpperCase()}
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
              </Tab>
            ))}
          </Tabs>
        </div>
        <div className="tabsButtons">
          <MdOutlineSwapVert
            variant="outline-primary"
            className="switch-tabtype"
            id="swaptabs"
            onClick={() => {
              toggleTabType()
            }}
          />
          {!esResumen && (
            <MdOutlineSettings
              variant="outline-primary"
              className="switch-filters"
              onClick={() => {
                setShowFilterOffcanvas(true)
              }}
            />
          )}
        </div>
        {props.filtros && props.filtros.length > 0 && (
          <FiltrosTabs
            filtros={props.filtros}
            showFilterOffcanvas={showFilterOffcanvas}
            setShowFilterOffcanvas={setShowFilterOffcanvas}
            activeFilters={activeFilters}
            cohortesusuario={cohortesusuario}
            addFilterCoordinadoraAdmision={addFilterCoordinadoraAdmision}
            deleteFilterCoordinadoraAdmision={deleteFilterCoordinadoraAdmision}
            addFilterCoordinadoraPrograma={addFilterCoordinadoraPrograma}
            deleteFilterCoordinadoraPrograma={deleteFilterCoordinadoraPrograma}
            changeGroupBy={changeGroupBy}
            groupby={groupby[index]}
            columns={columns}
            changeColumn={changeColumn}
            tipoColumnas={props.tipoColumnas}
            addColumn={addColumn}
            deleteColumn={deleteColumn}
            moveColumnUp={moveColumnUp}
            moveColumnDown={moveColumnDown}
            setFiltroFechaInicio={setFilterFechaInicio}
            deleteFilterFechaInicio={deleteFilterFechaInicio}
            index={props.tipoColumnas === "postulantes" ? index : props.view}
          />
        )}
      </div>
      {activeFilters &&
        activeFilters[index] &&
        ((activeFilters[index].coordinadorasadmision &&
          activeFilters[index].coordinadorasadmision.length > 0) ||
          (activeFilters[index].coordinadorasprogramas &&
            activeFilters[index].coordinadorasprogramas.length > 0) ||
          (activeFilters[index].fechainicio &&
            activeFilters[index].fechainicio.start &&
            activeFilters[index].fechainicio.end)) && (
          <div className="activeFilters">
            <ul>
              {activeFilters[index].coordinadorasadmision &&
                activeFilters[index].coordinadorasadmision.map((c) => (
                  <li key={c}>
                    {usuario.coordinadorasadmision[c].nombre}
                    <MdDeleteOutline
                      className="filtroDelete"
                      onClick={() => {
                        deleteFilterCoordinadoraAdmision(c)
                      }}
                    />
                  </li>
                ))}
              {activeFilters[index].coordinadorasprogramas &&
                activeFilters[index].coordinadorasprogramas.map((c) => (
                  <li key={c}>
                    {usuario.coordinadorasprogramas[c].nombre}
                    <MdDeleteOutline
                      className="filtroDelete"
                      onClick={() => {
                        deleteFilterCoordinadoraPrograma(c)
                      }}
                    />
                  </li>
                ))}
              {activeFilters[index].fechainicio &&
                activeFilters[index].fechainicio.start &&
                activeFilters[index].fechainicio.end && (
                  <li key={"fecha_inicio"}>
                    Desde:{" "}
                    {activeFilters[index].fechainicio.start.toLocaleDateString(
                      "es-CL"
                    )}{" "}
                    hasta:{" "}
                    {activeFilters[index].fechainicio.end.toLocaleDateString(
                      "es-CL"
                    )}
                    <MdDeleteOutline
                      className="filtroDelete"
                      onClick={() => {
                        deleteFilterFechaInicio()
                      }}
                    />
                  </li>
                )}
            </ul>
          </div>
        )}
    </>
  )
}

export default TabsFacultades
